import { Form } from "react-bootstrap";
import styled from "styled-components";

interface IProps {
  errorToDisplay: any;
}

export const Input = styled.div<IProps>`
  margin: 0.2rem 1rem;
  display: grid;
  align-items: center;

  label {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    span {
      font-size: 12px;
      margin-top: 2.3px;
    }

    input {
      height: 16px;
      width: 16px;
      text-align: start;
    }
  }
`;

export const Error = styled.div`
  font-size: 11px;
  color: #dc2229;
  margin-top: 0.2rem;
`;
